import { Role } from './role';
import { z } from 'zod';

export const ActiveRole = z.object({
    role: Role,
    depth: z.number(),
    asSubstituteOf: z.string().optional(),
});

export type ActiveRole = z.infer<typeof ActiveRole>;
